import {
  buildTechnologyProficiencyEntries,
  type ResolvedResource,
} from '@/features/Collaborators/utils/resourcePresentation';
import { CapabilityBadge } from '@/features/Collaborators/Shared/CapabilityBadge';

interface ProfileSkillsCardProps {
  resources?: ResolvedResource[] | null;
}

export function ProfileSkillsCard({ resources }: ProfileSkillsCardProps) {
  const safeResources = resources ?? [];
  const capabilityBadges = buildTechnologyProficiencyEntries(safeResources);

  if (safeResources.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-slate-200 bg-slate-50 px-4 py-5">
        <p className="text-sm font-medium text-slate-700">Nenhuma habilidade cadastrada.</p>
        <p className="mt-1 text-xs text-slate-500">
          Este perfil ainda não possui capacidades técnicas vinculadas.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {capabilityBadges.map((capability) => (
        <CapabilityBadge
          key={capability.key}
          capability={capability}
          showPrimary
        />
      ))}
    </div>
  );
}

export default ProfileSkillsCard;
